import { api } from './pos-api';
import { getActiveStore, getSelectedTenant } from './scope';
import { accessTokenClaims, accessSessionBinding } from './auth-session';

const cache = new Map(), pending = new Map(), queue = [];
let running = 0, bytes = 0;
const MAX_BYTES = 12 * 1024 * 1024, MAX_IMAGES = 160;

export function imageScope() {
  const token = localStorage.getItem('pos_token') || '';
  const claims = accessTokenClaims(token);
  return JSON.stringify([claims?.aud, claims?.sub, accessSessionBinding(token), getSelectedTenant(), getActiveStore()]);
}

const cacheKey = (src, scope) => JSON.stringify([scope, src]);
export function cachedImage(src, scope) {
  const key = cacheKey(src, scope), blob = cache.get(key);
  if (blob) { cache.delete(key); cache.set(key, blob); }
  return blob;
}

function pump() {
  while (running < 4 && queue.length) {
    const task = queue.shift();
    running += 1;
    task().finally(() => { running -= 1; pump(); });
  }
}

export function loadProductImage(src, scope) {
  const cached = cachedImage(src, scope);
  if (cached) return Promise.resolve(cached);
  const key = cacheKey(src, scope);
  if (pending.has(key)) return pending.get(key);
  const promise = new Promise((resolve, reject) => {
    queue.push(async () => {
      try {
        if (scope !== imageScope()) throw new Error('Image scope changed');
        const { data } = await api.get(src, { baseURL: window.location.origin, responseType: 'blob', timeout: 20000 });
        if (scope !== imageScope()) throw new Error('Image scope changed');
        cache.set(key, data); bytes += data.size;
        while (cache.size > MAX_IMAGES || bytes > MAX_BYTES) {
          const oldest = cache.keys().next().value;
          bytes -= cache.get(oldest).size; cache.delete(oldest);
        }
        resolve(data);
      } catch (error) { reject(error); }
      finally { pending.delete(key); }
    });
  });
  pending.set(key, promise); pump();
  return promise;
}
